import { Banner } from '@sunwebgroup/uds-ui/banner'
import { mqMax, tokPx } from '@sunwebgroup/ui-components'
import { Button } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { getDiscountsMoreInfoUrl } from '../../domain/policies/discountsMoreInfoUrl'

const StyledBanner = styled(Banner)`
  margin-bottom: ${tokPx('primitives_space_20')};
`

const ButtonContainer = styled(Banner.ActionsWrapper)`
  flex-shrink: 0;
  @media ${mqMax('primitives_breakpoint_s_max')} {
    margin-left: unset;
    margin-right: auto;
  }
`

const BannerContentWrapper = styled(Banner.ContentWrapper)`
  @media ${mqMax('primitives_breakpoint_s_max')} {
    flex-direction: column;
  }
`

interface DiscountBannerProps {
  discountAmount: number
}

export function DiscountBanner({ discountAmount }: DiscountBannerProps) {
  const intl = useIntl()
  const siteName = useConfiguration('siteName')
  const moreInfoUrl = getDiscountsMoreInfoUrl(siteName)

  return (
    <StyledBanner
      color="informative"
      size="M"
      hasIcon
      contentIsCentered
    >
      <BannerContentWrapper actionsPosition="right">
        <Banner.TextsWrapper>
          <Banner.Text>
            {intl.formatMessage({ id: 'bookings_overview_discounts_title' })}
          </Banner.Text>
          <Banner.SupportingText>
            {intl.formatMessage({
              id: 'bookings_overview_discounts_subtitle',
            }, {
              discountAmount: intl.formatCurrency(discountAmount),
            })}
          </Banner.SupportingText>
        </Banner.TextsWrapper>
        {moreInfoUrl && (
          <ButtonContainer actionsPosition="right">
            <Button
              variant="secondary"
              size="XS"
              forwardedAs="a"
              href={moreInfoUrl}
            >
              {intl.formatMessage({ id: 'bookings_overview_discounts_cta' })}
            </Button>
          </ButtonContainer>
        )}
      </BannerContentWrapper>
    </StyledBanner>
  )
}
